import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const PrintIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M4.88571 15.1714H1.8C1.23194 15.1714 0.771429 14.7109 0.771429 14.1429V7.97143C0.771429 7.40336 1.23194 6.94286 1.8 6.94286H16.2C16.7681 6.94286 17.2286 7.40336 17.2286 7.97143V14.1429C17.2286 14.7109 16.7681 15.1714 16.2 15.1714H13.1143M3.34286 12.0857H14.6571M4.88571 0.771429H13.1143V6.94286H4.88571V0.771429ZM4.88571 12.0857H13.1143V17.2286H4.88571V12.0857Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

PrintIcon.displayName = 'PrintIcon';
